import { DialogContent } from '@material-ui/core/';
import { Theme, withStyles } from '@material-ui/core/styles';

export const ClosableDialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(DialogContent);
